import { TitleBar } from 'adminConsole/layout'
import { QueryList } from 'adminConsole/page'

export const ListPage = () => {
  return (
    <>
      <TitleBar title="參數管理" />
      <QueryList />
    </>
  )
}
